export default "__VITE_ASSET__SgZrhhup__"